import { useId } from "react";

const IconBadge = ({
  label,
  size = 56,
  maxCharsPerLine = 6
}) => {
  const id = useId();
  const text = label.toUpperCase();

  // Split text into multiple lines safely
  const lines = [];
  for (let i = 0; i < text.length; i += maxCharsPerLine) {
    lines.push(text.slice(i, i + maxCharsPerLine));
  }

  // Dynamic font sizing based on number of lines
  const fontSize =
    lines.length === 1 ? 36 :
    lines.length === 2 ? 26 :
    lines.length === 3 ? 20 : 16;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 140 140"
      style={{
        display: "block",
        flexShrink: 0,
        maxWidth: size,
        maxHeight: size
      }}
      role="img"
      aria-label={label}
    >
      <defs>
        <linearGradient id={id} gradientTransform="rotate(20)">
          <stop offset="0%" stopColor="#1a3067" />
          <stop offset="100%" stopColor="#257df9" />
        </linearGradient>
      </defs>

      {/* Background */}
      <rect
        x="4"
        y="4"
        width="132"
        height="132"
        rx="28"
        fill={`url(#${id})`}
      />

      {/* Inner border */}
      <rect
        x="10"
        y="10"
        width="120"
        height="120"
        rx="24"
        fill="none"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth="2"
      />

      {/* Text */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#fff"
        fontWeight="700"
        fontFamily="Inter, system-ui, Arial, sans-serif"
        fontSize={fontSize}
      >
        {lines.map((line, i) => (
          <tspan
            key={i}
            x="50%"
            dy={i === 0 ? 0 : "1.1em"}
          >
            {line}
          </tspan>
        ))}
      </text>
    </svg>
  );
};

export default IconBadge;
